import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { warehouseService } from "./services/warehouseService";
import { WarehouseTable } from "./components/warehouse/WarehouseTable";
import { useFactory } from '../../context/FactoryContext';
const AlmacenRepuestos = () => {

    const { selectedFactory } = useFactory();

    const { data: warehouses, isLoading, error } = useQuery({
        queryKey: ["warehouses", selectedFactory],
        queryFn: () => warehouseService.getWarehouses(),
        enabled: true,
    });

    console.log(warehouses);







    if (isLoading) {
        return (
            <div>
                <p>Loading...</p>
            </div>
        );
    }


    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Spare Parts Warehouse</h1>
            {/* Aquí puedes agregar el contenido de la página de asignación de trabajo */}
            <WarehouseTable
                warehouses={warehouses} />
        </div>
    );
};

export default AlmacenRepuestos;
